<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div
        style="display: flex"
        class="mbl-gen justify-content-between align-items-center"
      >
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/distribution.svg" />
          </div>
          <div>
            <div class="card_title_1">DISTRIBUTION</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <div class="mbl-gen">
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis' }"
            @click="selectTab('reg_opdis')"
          >
            All
          </span>
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis_sumkal' }"
            @click="selectTab('reg_opdis_sumkal')"
          >
            Sumatera & Kalimantan
          </span>
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis_jamali' }"
            @click="selectTab('reg_opdis_jamali')"
          >
            Jawa, Madura & Bali
          </span>
          <span
            class="text-detail"
            :class="{
              'area-tab-selected': selectedTab === 'reg_opdis_sulmapana',
            }"
            @click="selectTab('reg_opdis_sulmapana')"
          >
            Sulawesi, Papua, Maluku & Nusa Tenggara
          </span>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row mb-4">
        <div class="col-md-4">
          <h5 class="mx-0 mb-4 sub_title_1">
            EFFICIENCY
            <span
              :style="`background-color:${efficiencyColor}`"
              class="safety-dot"
            ></span>
          </h5>
          <div class="row">
            <div class="col-md-6" style="padding: 0 4px">
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[0] != null
                "
                :param="distribution.efficiency[0]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[0].metricId"
                @click="selectCard(distribution.efficiency[0])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[1] != null
                "
                :param="distribution.efficiency[1]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[1].metricId"
                @click="selectCard(distribution.efficiency[1])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-md-6" style="padding: 0 4px">
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[2] != null
                "
                :param="distribution.efficiency[2]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[2].metricId"
                @click="selectCard(distribution.efficiency[2])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[3] != null
                "
                :param="distribution.efficiency[3]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[3].metricId"
                @click="selectCard(distribution.efficiency[3])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <h5 class="mx-0 mb-4 sub_title_1">
            QUALITY<span
              :style="`background-color:${qualityColor}`"
              class="safety-dot"
            ></span>
          </h5>

          <CardWhite
            v-if="distribution != null && distribution.quality[0] != null"
            :param="distribution.quality[0]"
            :height="150"
            :selected="selectedCard === distribution.quality[0].metricId"
            @click="selectCard(distribution.quality[0])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.quality[1] != null"
            :param="distribution.quality[1]"
            :height="150"
            :selected="selectedCard === distribution.quality[1].metricId"
            @click="selectCard(distribution.quality[1])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
        </div>
        <div class="col-md-6">
          <h5 class="mx-0 mb-4 sub_title_1">
            RELIABILITY<span
              :style="`background-color:${realibityColor}`"
              class="safety-dot"
            ></span>
          </h5>
          <div class="row">
            <div class="col gm-mobile" style="padding: 0 4px">
              <CardWhite
                class="height-mobile"
                v-if="distribution != null && distribution.realibity[0] != null"
                :param="distribution.realibity[0]"
                :height="308"
                :selected="selectedCard === distribution.realibity[0].metricId"
                @click="selectCard(distribution.realibity[0])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col gm-mobile" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[1] != null"
                :param="distribution.realibity[1]"
                :height="308"
                :selected="selectedCard === distribution.realibity[1].metricId"
                @click="selectCard(distribution.realibity[1])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col gm-mobile" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[2] != null"
                :param="distribution.realibity[2]"
                :height="308"
                :selected="selectedCard === distribution.realibity[2].metricId"
                @click="selectCard(distribution.realibity[2])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-5 potrait-card" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[3] != null"
                :param="distribution.realibity[3]"
                :height="150"
                :selected="selectedCard === distribution.realibity[3].metricId"
                @click="selectCard(distribution.realibity[3])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="distribution != null && distribution.realibity[4] != null"
                :param="distribution.realibity[4]"
                :height="150"
                :selected="selectedCard === distribution.realibity[4].metricId"
                @click="selectCard(distribution.realibity[4])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-10 gm-mobile">
          <div class="mbl-gen header-top m-t-5 m-b-20">
            <h5 style="text-transform: capitalize" class="m-0">
              {{ titleDetail }}
            </h5>
            <div style="display: flex; gap: 20px">
              <div class="card-header-right-icon">
                <span
                  style="font-weight: bold"
                  class="badge badge-light text-dark"
                  >Total Units (selected region): {{ totalData }}</span
                >
                <span class="mbl-gen badge badge-light text-dark">
                  Status:
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-checkcircle-red.svg"
                  />
                  Below Target ({{ statusBelow }})
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-checkcircle-blue.svg"
                  />
                  Above Target ({{ statusAbove }})
                  <!-- <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-region-red.svg"
                  />
                  Region Below Target (1)
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-region-green.svg"
                  />
                  Region Above Target (2) -->
                </span>
              </div>
            </div>
          </div>
          <div>
            <l-map
              :zoom="simple.zoom"
              :center="simple.center"
              :options="simple"
              :zoomControl="false"
              :dragging="false"
              style="height: 740px; z-index: 0"
            >
              <l-tile-layer :url="simple.url"></l-tile-layer>
              <l-marker
                v-for="(marker, index) in distributionMap.sumkal"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="getIcon(marker)"
                :key="index"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  <div class="unit-card">
                    <div
                      class="status-bar"
                      :style="{ backgroundColor: marker.metrics[0].color }"
                    ></div>
                    <div class="unit-info">
                      <span class="unit-name"> {{ marker.instanceName }}</span
                      ><br />
                      <span
                        v-for="(metric, id) in marker.metrics"
                        :key="id"
                        class="unit-status"
                        >{{ formattedNumber(metric.value) }}
                        {{ metric.unit }}</span
                      >
                    </div>
                  </div>
                </l-tooltip>
              </l-marker>
              <l-marker
                v-for="(marker, index) in distributionMap.jamali"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="getIcon(marker)"
                :key="index"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  <div class="unit-card">
                    <div
                      class="status-bar"
                      :style="{ backgroundColor: marker.metrics[0].color }"
                    ></div>
                    <div class="unit-info">
                      <span class="unit-name"> {{ marker.instanceName }}</span
                      ><br />
                      <span
                        v-for="(metric, id) in marker.metrics"
                        :key="id"
                        class="unit-status"
                        >{{ formattedNumber(metric.value) }} %</span
                      >
                    </div>
                  </div>
                </l-tooltip>
              </l-marker>
              <l-marker
                v-for="(marker, index) in distributionMap.sulmapana"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="getIcon(marker)"
                :key="index"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  <div class="unit-card">
                    <div
                      class="status-bar"
                      :style="{ backgroundColor: marker.metrics[0].color }"
                    ></div>
                    <div class="unit-info">
                      <span class="unit-name"> {{ marker.instanceName }}</span
                      ><br />
                      <span
                        v-for="(metric, id) in marker.metrics"
                        :key="id"
                        class="unit-status"
                        >{{ formattedNumber(metric.value) }} %</span
                      >
                    </div>
                  </div>
                </l-tooltip>
              </l-marker>
            </l-map>
          </div>
        </div>
        <div class="col-2 gm-mobile mt-mobile" style="padding: 0 4px">
          <h5 class="mx-0 mb-4 sub_title_1">
            SAFETY<span
              :style="`background-color:${safetyColor}`"
              class="safety-dot"
            ></span>
          </h5>

          <CardWhite
            v-if="distribution != null && distribution.safety[0] != null"
            :param="distribution.safety[0]"
            :height="150"
            :selected="selectedCard === distribution.safety[0].metricId"
            @click="selectCard(distribution.safety[0])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[1] != null"
            :param="distribution.safety[1]"
            :height="150"
            :selected="selectedCard === distribution.safety[1].metricId"
            @click="selectCard(distribution.safety[1])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[2] != null"
            :param="distribution.safety[2]"
            :height="150"
            :selected="selectedCard === distribution.safety[2].metricId"
            @click="selectCard(distribution.safety[2])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[3] != null"
            :param="distribution.safety[3]"
            :height="150"
            :selected="selectedCard === distribution.safety[3].metricId"
            @click="selectCard(distribution.safety[3])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[4] != null"
            :param="distribution.safety[4]"
            :height="150"
            :selected="selectedCard === distribution.safety[4].metricId"
            @click="selectCard(distribution.safety[4])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
        </div>
      </div>
    </div>
    <ModalDistributionMapVue
      :showModal="modalMap.show"
      :dataMap="dataMap"
      :titleMap="titleMap"
      @closeModal="onCloseModalMap"
      :distribution="distribution"
    ></ModalDistributionMapVue>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { latLng, icon } from "leaflet";

import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();

import CardWhite from "./CardWhite.vue";
import { formattedNumber } from "@/utils/helper";
import CardWhiteNull from "./CardWhiteNull.vue";
import ModalDistributionMapVue from "../modals/ModalDistributionMap.vue";
import "leaflet/dist/leaflet.css";

export default {
  components: {
    IconSvg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    CardWhite,
    CardWhiteNull,
    ModalDistributionMapVue,
  },
  data() {
    return {
      efficiencyColor: "",
      qualityColor: "",
      realibityColor: "",
      safetyColor: "",
      totalData: "",
      statusBelow: "",
      statusAbove: "",
      dataMap: [],
      titleMap: "",
      simple: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        zoom: 5,
        minZoom: 3,
        maxZoom: 18,
        center: [-1.8263233, 118.3522204],
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        iconBlue: icon({
          iconUrl: "map-marker-circle-blue.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
        iconRed: icon({
          iconUrl: "map-marker-circle-red.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
      },
      last_update: "",
      cities: "all",

      distribution: null,
      distributionMap: [],
      selectedTab: "reg_opdis",
      selectedCard: 0,
      modalMap: {
        show: false,
        load: false,
      },
      titleDetail: "",
    };
  },
  created() {
    this.getDataDistribution("reg_opdis");
    this.getResolution();
    // this.getDataDistributionMap();
  },
  methods: {
    getIcon(item) {
      return L.divIcon({
        className: "my-custom-pin",
        html: `<div style="background-color: ${item.metrics[0].color}; width: 10px; height: 10px; border-radius: 50%;"></div>`,
        iconSize: [16, 16], // Size of the icon
        iconAnchor: [8, 8], // Anchor the icon to the center
      });
    },
    getResolution() {
      this.simple.dragging = window.screen.width < 760 ? true : false;
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    clickMarker(x) {
      this.modalMap.show = true;
      this.dataMap = x;
    },
    selectTab(tab) {
      this.getDataDistribution(tab);
      this.selectedTab = tab;
    },

    selectCard(id) {
      this.selectedCard = id.metricId;
      // this.titleDetail = id.metricName + " " + `(${id.unit})`;
      this.titleDetail = id.metricName;
      this.getDataDistributionMap(id.metricId, this.selectedTab);
    },

    async getDataDistribution(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistribution(param);
      if (res && res.status == 200) {
        this.efficiencyColor = res.data.data.efficiencyStatus;
        this.qualityColor = res.data.data.qualityStatus;
        this.realibityColor = res.data.data.realibityStatus;
        this.safetyColor = res.data.data.safetyStatus;
        const datas = res.data.data.efficiency[0];
        this.selectCard(datas);
        this.last_update = res.data.lastUpdate;
        this.titleDetail = datas.metricName;
        this.distribution = res.data.data;
      }
    },

    async getDataDistributionMap(id, instance) {
      let param = Object.assign({
        instance: instance,
        metricId: id,
      });
      const res = await apiDistribution.getDataDistributionMap(param);
      if (res && res.status == 200) {
        this.totalData = res.data.data.totalData;
        this.statusBelow = res.data.data.statusBelow;
        this.statusAbove = res.data.data.statusAbove;
        this.distributionMap = res.data.data;
      }
    },
    formattedNumber,
  },
};
</script>

<style scoped>
.area-tab-selected {
  padding: 5px 10px;
  border-radius: 8px;
  background-color: #00a3e9;
  color: #fff;
}

.sub_title_3 {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  letter-spacing: 0.02em;
  text-align: left;
}

.data_text_2 {
  font-size: 20px;
  font-weight: 700;
  line-height: 24.2px;
  text-align: left;
}

.unit-card {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  background-color: #333;
  color: white;
}

.status-bar {
  width: 5px;
  height: 30px;
  margin-right: 10px;
  border-radius: 3px;
  background-color: #00a3e9;
}

.unit-info {
  flex-grow: 1;
}
.safety-dot {
  width: 12px;
  height: 12px;
  background-color: #ff4444;
  border-radius: 50%;
  display: inline-block;
  margin-left: 7px;
}
</style>
